function InnerBanner({ image,MobileBanner, title, subtitle, skew, bannershow, titleClass = "" }) {
  const defaultTitle =
  "text-[34px] md:text-[4.625rem] leading-tight text-white font-SaudiaBold";
  return (
    <>
    {(bannershow) && (
      <section
        className={`relative w-full max-h-[650px] flex items-center overflow-hidden inner-banner ${skew ? "" : ""}`}
        >
        <img src={image} className="w-full h-full object-cover hidden md:block" />
        <img src={MobileBanner} className="w-full h-full object-cover md:hidden" />

        {/* {(title || subtitle) && (
          <div className="absolute py-10 md:py-0 px-6 md:px-8 lg:px-14 inset-x-0 w-full bottom-0 md:top-0 md:h-full flex items-center z-20">
            <div className="container max-w-8xl mx-auto px-2 py-8 md:py-0 md:px-8 2xl:px-32 grid grid-cols-12">
            <div className="col-span-8 md:col-span-6">
              {title && (
                <h1 className={titleClass?.trim() ? titleClass : defaultTitle}>
                  {title}
                </h1>
              )}

              {subtitle && (
                <p className="mt-4 text-xl font-SaudiaLight">{subtitle}</p>
              )}
            </div>
            </div>
          </div>
        )} */}
      </section>      
    )}
    </>
  );
}

export default InnerBanner;
